import PropTypes from 'prop-types';
// hooks
import useRelationshipManager from '../../../hooks/useRelationshipManager';
// components
import { RelationshipManagerCard } from '../../../components/relationship-manager-card';

// ----------------------------------------------------------------------

NavRelationshipManager.propTypes = {
  compact: PropTypes.bool,
};

/**
 * Sidebar slot for the current partner's relationship manager. Renders
 * nothing while loading, for root partners, and when none is assigned.
 */
export default function NavRelationshipManager({ compact = false }) {
  const { manager, isLoading } = useRelationshipManager();

  if (isLoading || !manager) return null;

  return <RelationshipManagerCard manager={manager} compact={compact} />;
}
